import { useSelector } from 'react-redux'
import styled from 'styled-components'
import PageTopTitle from '../../components/shared/PageTopTitle'
import { useEffect, useState } from 'react'
import { getDatee } from '../../helper/getDatee'
import { getTime } from '../../helper/getTime'
import InputDate from '../../components/shared/input/new/InputDate'
import InputTime from '../../components/shared/input/new/InputTimeNew'
import InputSelect from '../../components/shared/input/new/InputSelect'
import InputNumberNew from '../../components/shared/input/new/InputNumberNew'
import InputText from '../../components/shared/input/new/InputText'
import { faturaTipiData, tevkifatData } from '../../utils/EArsivFaturaOptions'
import InputNumberWithSuffix from '../../components/shared/input/new/InputNumberWithSuffix'
import Button from "../../components/shared/button/Btn"
import Btn from '../../components/shared/button/Btn'
import { useDispatch } from 'react-redux'
import InputCityTown from '../../components/shared/input/new/InputCityTown'
import { nanoid } from '@reduxjs/toolkit'
import { createEArsivInvoice, createEArsivLocationPrice, getMernisDataEArsiv, getTevkifatData } from '../../features/e-Arsiv/eArsivSlice'
import SmallSpinner from '../../components/shared/spinners/SmallSpinner'
import { getKdv } from '../../features/calc/calcSlice'
import TevkifatInput from '../../components/shared/input/new/TevkifatInput'
import useWindowDimensions from '../../hooks/useWindowSize'

const Container = styled.div`
  width: 100%;
  height: 100%;
    .wrapper{
      width: 100%;
      padding: 30px;
      .content{
        display: flex;
        justify-content: start;
        gap: 60px;
        .col{
            width: 600px;
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-bottom: 20px;

            .invoice-info{
                display: flex;
                align-items: center;
                gap: 15px;
                .info{
                    text-decoration: underline;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }
                .delete{
                    text-decoration: underline;
                    color: var(--color-main);
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    cursor: pointer;
                }
            }
            .row{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                button{
                    width: 20%;
                }
            }
        }
      }
    }


    @media (max-width: 850px){
        .content{
            flex-direction: column !important;
            gap: 0px !important;
            .col{
                width: 100% !important;
            }
        }
       
    }
`
const EArsivFaturaKes = () => {
  const dispatch = useDispatch()
  const {isLoadingCreateInvoice, mernisDataEArsiv, tevkifatCodes} = useSelector(state => state.eArsiv)
  const {windowDimensions} = useWindowDimensions()
  
  const {kdvData} = useSelector(state => state.calc)
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const gibToken = JSON.parse(storage.getItem("gibToken"))
  const gibCallId = JSON.parse(storage.getItem("gibCallId"))
  const gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"))

  useEffect(() => {
    dispatch(getTevkifatData())
    dispatch(getKdv())
  }, [])

  const [faturaTipi, setFaturaTipi] = useState({
    id: 1,
    text: "Satış",
    value: "SATIS"
  })

  const [tevkifatOrani, setTevkifatOrani] = useState(tevkifatCodes.find(item => item.id === 24))
  const [toplamTutarWithKdv, setToplamTutarWithKdv] = useState(null)
  const [toplamTutarWithoutKdv, setToplamTutarWithoutKdv] = useState(null)

  const [neredenData, setNeredenData] = useState(null)
  const [nereyeData, setNereyeData] = useState(null)

  const newInvoiceData = {
        malHizmet: "",
        birimFiyat: ""
  }

  const [invoiceDatas, setInvoiceDatas] = useState([
    {
        id: nanoid(),
        malHizmet: "",
        birimFiyat: ""
    }
  ])
 
  const [data, setData] = useState({
    duzenlemeTarihi: getDatee(),
    duzenlemeSaati: getTime(),
    aliciVergiTcNo:"",
    unvanAdSoyad:"",
    vergiDairesi:"",
    adres:"",
    irsaliyeTarihi:"",
    irsaliyeNo:"",
    toplamFiyat:"",
    kullaniciNot: ""
  })

  const handleChange = (e) => {
    setData((prev) => ({...prev, [e?.target?.name]: e?.target?.value}))
  }

  const handleChangeInvoice = (e, id) => {
    const {name, value} = e.target
    setInvoiceDatas((prevInvoiceDatas) =>
        prevInvoiceDatas.map((item) => 
            item.id === id ? { ...item, [name]: value } : item
        )
    );
  }

  useEffect(() => {
    const toplamFiyat = invoiceDatas.reduce((acc, curr) => {
        const fiyat = parseInt(curr.birimFiyat) || 0;
        return acc + fiyat;
    }, 0);
    setData((prev) => ({...prev, toplamFiyat: toplamFiyat}))
  }, [invoiceDatas])

  useEffect(() => {
    const toplamFiyat =  parseInt(data?.toplamFiyat)
    const kdvOraniNum = parseInt(kdvData)
    const tutar = toplamFiyat * (kdvOraniNum / 100);
    setToplamTutarWithKdv(toplamFiyat + tutar)
    setToplamTutarWithoutKdv(toplamFiyat)
  },[data, data?.toplamFiyat, kdvData])

  const handleSubmit = () => {
    const addData = {
        "authInfoDto": {
          "token": gibToken,
          "callId": gibCallId,
          "callIdCount": gibCallIdCount
        },
        "vknTckn": data?.aliciVergiTcNo,
        "countryName": "Türkiye",
        "address": data?.adres,
        "note": data?.kullaniciNot,
        "invoiceType": faturaTipi?.value,
        "tevkifatCode": tevkifatOrani?.code,
        "invoiceDatas": invoiceDatas?.map((item) => { return ( {goodsOrServicesName: item?.malHizmet, goodsOrServicesPrice: item?.birimFiyat?.split(' ')[0]?.replace(",", ".")} )})
    }

    const locationPriceData = {
        neredenIlKey: parseInt(neredenData?.cityId),
        neredenIlName: neredenData?.city,
        neredenIlceKey: parseInt(neredenData?.townId),
        neredenIlceName: neredenData?.town,
        nereyeIlKey: parseInt(nereyeData?.cityId),
        nereyeIlName: nereyeData?.city,
        nereyeIlceKey: parseInt(nereyeData?.townId),
        nereyeIlceName: nereyeData?.town,
        fiyat: data?.toplamFiyat,
        yüktürü: invoiceDatas.map(data => data?.malHizmet).join(', ')
    }
    if(gibToken){
        dispatch(createEArsivInvoice(addData))
        dispatch(createEArsivLocationPrice(locationPriceData))
    }
  }

  const addNewInvoiceData = () => {
    setInvoiceDatas((prev) => ([...prev, {...newInvoiceData, id: nanoid()}]))
  }

  const deleteInvoiceData = (id) => {
    const filterInvoiceDatas = invoiceDatas?.filter((item) => {
        return item?.id !== id
    })
    setInvoiceDatas(filterInvoiceDatas)
  }

  return (
    <Container>
        <PageTopTitle title={"e-Arşiv Fatura Kes"} position='sticky' isDiffPage top={windowDimensions?.width < 850 ? "0px" : '210px'}/>

        <div className="wrapper">
            <div className="content">
                <div className="col">
                    {/* <div className="row">
                        <InputDate data={data?.duzenlemeTarihi} setData={(e) => handleChange(e)} name={"duzenlemeTarihi"} labelText={"Düzenleme Tarihi"} inputWidth={"100%"} />
                    </div>

                    <div className="row">
                        <InputTime data={data?.duzenlemeSaati} setData={(e) => handleChange(e)} name={"duzenlemeSaati"} labelText={"Düzenleme Saati"} inputWidth={"100%"} />
                    </div> */}
                    
                    <div className="row">
                        <InputSelect data={faturaTipi?.text} setData={setFaturaTipi} name={"faturaTipi"} labelText={"Fatura Tipi"} initialOptions={faturaTipiData} inputWidth={"100%"} />
                    </div>

                    <div className="row">
                        <InputNumberNew data={data?.aliciVergiTcNo} setData={(e) => handleChange(e)} name={"aliciVergiTcNo"} labelText={"Alıcı Vergi No / TC No"} inputWidth={"75%"} />
                        <Button handleClick={() => dispatch(getMernisDataEArsiv(data?.aliciVergiTcNo))} bgColor='transparent' color='#E85446' padding='0px 10px' >Sorgula</Button>
                    </div>

                    <div className="row">
                        <InputText disabled={true} data={mernisDataEArsiv ? mernisDataEArsiv?.name + `${" "}` + mernisDataEArsiv?.surname: ""} setData={(e) => handleChange(e)} name={"unvanAdSoyad"} labelText={"Ünvanı / Adı Soyadı"} inputWidth={"100%"} />
                    </div>

                    <div className="row">
                        <InputText disabled={true} data={mernisDataEArsiv?.taxOffice} setData={(e) => handleChange(e)} name={"vergiDairesi"} labelText={"Vergi Dairesi"} inputWidth={"100%"} />
                    </div>
                        
                    <div className="row">
                        <InputText data={data?.adres} setData={(e) => handleChange(e)} name={"adres"} labelText={"Adres"} inputWidth={"100%"} />
                    </div>

                    <div className="row">
                        <InputDate data={data?.irsaliyeTarihi} setData={(e) => handleChange(e)} name={"irsaliyeTarihi"} labelText={"İrsaliye Tarihi"} inputWidth={"100%"} />
                    </div>

                    <div className="row">
                        <InputNumberNew data={data?.irsaliyeNo} setData={(e) => handleChange(e)} name={"irsaliyeNo"} labelText={"İrsaliye No"} inputWidth={"100%"} />
                    </div>
                    
                    <div className="row">
                        <InputCityTown data={neredenData?.location} setData={setNeredenData} name={"nereden"} labelText={"Nereden"} inputWidth={"100%"} />
                    </div>

                    <div className="row">
                        <InputCityTown data={nereyeData?.location} setData={setNereyeData} name={"nereye"} labelText={"Nereye"} inputWidth={"100%"} />
                    </div>

                    <div className="row">
                        <InputNumberNew disabled={true} data={kdvData}  name={"kdvOrani"} labelText={"KDV Oranı (%)"} inputWidth={"100%"} />

                        {/* <InputSelect data={kdvOrani} setData={setKdvOrani} name={"kdvOrani"} labelText={"KDV Oranı (%)"} inputWidth={"100%"} initialOptions={kdvData} /> */}
                    </div>
                    
                    {faturaTipi?.id === 3 && 
                        <div className="row">
                            <TevkifatInput data={`${(tevkifatOrani?.code)} - ${tevkifatOrani.description}`} setData={setTevkifatOrani} initialOptions={tevkifatCodes} name={"tevkifatOrani"} labelText={"Tevkifat Oranı (%)"} inputWidth={"100%"} />
                        </div>
                    }
                    
                    {/* //! birim ve miktar bilgileri var ise disabled oluyor */}
                    <div className="row">
                        <InputNumberWithSuffix noneSeperator disabled={true} data={data?.toplamFiyat} setData={(e) => handleChange(e)} name={"toplamFiyat"} labelText={"Toplam Fiyat"} suffix=" TL" inputWidth={"100%"} />
                    </div> 

                    <div className="row">
                        <InputNumberWithSuffix noneSeperator disabled={true} data={toplamTutarWithKdv} setData={(e) => setToplamTutarWithKdv(e.target.value)} name={"toplamTutar"} labelText={"Toplam Tutar (KDV Dahil)"} inputWidth={"100%"} suffix={" TL"} />
                    </div>

                    <div className="row">
                        <InputNumberWithSuffix noneSeperator disabled={true} data={toplamTutarWithoutKdv} setData={(e) => setToplamTutarWithoutKdv(e.target.value)} name={"toplamTutar"} labelText={"Toplam Tutar (KDV Hariç)"} inputWidth={"100%"} suffix={" TL"} />
                    </div> 
                    

                    <div className="row">
                        <InputText data={data?.kullaniciNot} setData={(e) => handleChange(e)} name={"kullaniciNot"} labelText={"Not"} inputWidth={"100%"} />
                    </div>
                </div>

                <div className="col">
                    {
                        invoiceDatas?.map((item, i) => {
                            const index = i + 1
                            return (
                            <>
                                {invoiceDatas?.length > 1 && 
                                    <div className="invoice-info">
                                        <div className="info">{index}. Mal/Hizmet</div>
                                        <div className="delete" onClick={() => deleteInvoiceData(item.id)} >Sil</div>
                                    </div>
                                }
                                <div className="row">
                                    <InputText data={item?.malHizmet} setData={(e) => handleChangeInvoice(e, item.id)} name={`malHizmet`} labelText={"Mal / Hizmet"} inputWidth={"100%"} />
                                </div>

                                <div className="row">
                                    <InputNumberWithSuffix noneSeperator data={item?.birimFiyat} setData={(e) => handleChangeInvoice(e, item.id)} name={`birimFiyat`} labelText={"Birim Fiyat"} suffix=" TL" inputWidth={"100%"} />
                                </div>
                            </>
                        )})
                    }
                    <Btn color='#E85446' bgColor='transparent' padding='10px' width={"150px"} handleClick={addNewInvoiceData}>Mal/Hizmet Ekle</Btn>
                </div>
            </div>
            
            <Btn handleClick={handleSubmit} color='#E85446' bgColor='transparent' padding='10px' width={"150px"}>{ isLoadingCreateInvoice ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"} /> : "Gönder"}</Btn>

        </div>
    </Container>
  )
}

export default EArsivFaturaKes